import { render, staticRenderFns } from "./BigPayForm.vue?vue&type=template&id=0a989cf0&scoped=true&"
import script from "./BigPayForm.vue?vue&type=script&lang=ts&"
export * from "./BigPayForm.vue?vue&type=script&lang=ts&"
import style0 from "./BigPayForm.vue?vue&type=style&index=0&id=0a989cf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a989cf0",
  null
  
)

export default component.exports